import { useMemo } from 'react';
import { computeRoadBreakdown } from '../../utils/curviness';
import './RoadBreakdown.css';

/** Curves-vs-straight split for a route. Renders nothing for trivial geometry. */
export function RoadBreakdown({ geometry }) {
  const b = useMemo(() => computeRoadBreakdown(geometry), [geometry]);
  if (!b) return null;
  return (
    <div className="road-breakdown">
      <div className="road-breakdown__head">
        <span className="road-breakdown__label">Road type</span>
        <span className="road-breakdown__hero">{b.curvyPct}% curves</span>
      </div>
      <div className="road-breakdown__bar">
        {b.curvyPct > 0 && <span className="road-breakdown__seg road-breakdown__seg--curvy" style={{ width: `${b.curvyPct}%` }} />}
        {b.straightPct > 0 && <span className="road-breakdown__seg road-breakdown__seg--straight" style={{ width: `${b.straightPct}%` }} />}
      </div>
      <div className="road-breakdown__legend">
        <span className="road-breakdown__key"><i className="road-breakdown__dot road-breakdown__dot--curvy" /> Curves {b.curvyPct}%</span>
        <span className="road-breakdown__key"><i className="road-breakdown__dot road-breakdown__dot--straight" /> Straight {b.straightPct}%</span>
      </div>
    </div>
  );
}
